import React, { useContext } from 'react';
import classnames from 'classnames';
import Sidebar from '../../../Sidebar';
import { useDeviationViewContext } from '../../../Context/DeviationViewContext';
import LoadingIndicator from '../../../LoadingIndicator';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import SubPaywall from '../../../DeviationViews/Full/_partials/SubPaywall';
import { getDeviationType } from '../../../DeviationViews/_helpers';
import { DeviationTypes } from '../../../types/deviation';
import { getCommentableTypeForDeviationType, isExtendedDeviationFullyLoaded } from '../../redux/helpers';
import Comments from '../Comments';
import TierUpsell from '../TierUpsell';
import SecondaryActionBarWrapper from './SecondaryActionBarWrapper';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import s from './DesktopLayout.scss';
const DesktopLayout = ({ stageContent , metaContent , className , stageClassName , metaClassName , backgroundContent , backgroundClassName , withSecondaryActionBar =false , deviation , deviation: { deviationId , typeId  } , adContent  })=>{
    const { isTheater  } = useDeviationViewContext();
    const isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    const { adsEnabled  } = useContext(SessionContext);
    const { tier , isTier , isSubscribedButBlocked , needsSubscription  } = useSubscriptionTier(deviation);
    const isBlocked = needsSubscription || isSubscribedButBlocked;
    const isLongformText = [
        DeviationTypes.JOURNAL,
        DeviationTypes.LITERATURE
    ].includes(getDeviationType(deviation));
    const useLowerLeftColumnPaywall = isBlocked && isLongformText;
    const commentableTypeId = getCommentableTypeForDeviationType(typeId);
    // we -don't- show the tier upsell when locked-subscribed (desktop only)
    const showTierUpsell = (!!tier || isTier) && !useLowerLeftColumnPaywall && !isSubscribedButBlocked;
    const leftColumnTheaterClasses = classnames(s['left-column'], s['force-theater-full'], metaClassName);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, adContent && adContent, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], isTheater && s['theater'], !backgroundContent && s['no-background'], adsEnabled && s['with-ad'], className)
    }, backgroundContent && /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['background'], backgroundClassName)
    }, backgroundContent), /*#__PURE__*/ React.createElement(SecondaryActionBarWrapper, {
        deviation: deviation,
        withSecondaryActionBar: withSecondaryActionBar && !isBlocked,
        className: leftColumnTheaterClasses
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['art-stage'], stageClassName)
    }, stageContent), !isTheater && /*#__PURE__*/ React.createElement(Sidebar, {
        deviation: deviation,
        className: classnames(s['right-column'], s['sidebar'])
    }), /*#__PURE__*/ React.createElement("div", {
        className: leftColumnTheaterClasses
    }, metaContent)), isTheater && /*#__PURE__*/ React.createElement(Sidebar, {
        deviation: deviation,
        className: classnames(s['right-column'], s['sidebar'])
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['left-column']
    }, useLowerLeftColumnPaywall && /*#__PURE__*/ React.createElement(SubPaywall, {
        className: s['paywall'],
        deviation: deviation,
        showImage: false
    }), !isBlocked && /*#__PURE__*/ React.createElement(React.Fragment, null, isExtendedLoaded && /*#__PURE__*/ React.createElement(Comments, {
        key: `comments-${commentableTypeId}:${deviationId}`,
        deviation: deviation,
        className: s['comments']
    }), !isExtendedLoaded && /*#__PURE__*/ React.createElement(LoadingIndicator, {
        className: s['lloader'],
        view: "llama"
    })), showTierUpsell && /*#__PURE__*/ React.createElement(TierUpsell, {
        className: s['upsell'],
        deviation: deviation
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['clear']
    })));
};
DesktopLayout.displayName = 'DesktopLayout';
export default DesktopLayout;
